<template>
  <el-select
    v-model="value"
    :multiple="multiple"
    filterable
    :clearable="clearable "
    :filter-method="filterNode"
    :placeholder="placeholder"
    :style="`width: ${width}px;`"
  >
    <span class="tips" v-if="multiple==true">点击城市名称可进行全选或取消全选</span>
    <el-option-group
      v-for="group in options"
      :key="group.id"
      :label="group.name"
      @click.native="checkAll(group.id)"
    >
      <el-option
        v-for="item in group.children"
        :key="item.id"
        :label="item.name"
        :value="item.id"
      />
    </el-option-group>
  </el-select>
</template>

<script>
  export default {
    name: "人员选择组件",
    props:{
      /* 选项列表数据(分组对象数组) */
      options:{
        type: Array,
        default: ()=>{ return [] }
      },
      /* 初始值 */
      value:{
        type: Array,
        default: ()=>{ return [] }
      },
      /*宽*/
      width:{
        type: String,
        default: ()=>{ return '200' }
      },
      /*多选*/
      multiple:{
        type: Boolean,
        default: ()=>{ return false }
      },
      /*情况*/
      clearable:{
        type: Boolean,
        default: ()=>{ return true }
      },
      placeholder:{
        type:String,
        default:()=>{return '请选择'}
      },
      name:{
        type:String,
        default:()=>{return ''}
      },
      //顶级机构ID
      orgId:{
        type:String,
        default:()=>{return '-1'}
      }
    },
    data() {
      return {
        // options: [{
        //   name: '热门城市',
        //   id:'remen',
        //   children: [{
        //     id: 'Shanghai',
        //     name: '上海'
        //   }, {
        //     id: 'Beijing',
        //     name: '北京'
        //   }]
        // }, {
        //   name: '城市名',
        //   id:'chengshiming',
        //   children: [{
        //     id: 'Chengdu',
        //     name: '成都'
        //   }, {
        //     id: 'Shenzhen',
        //     name: '深圳'
        //   }, {
        //     id: 'Guangzhou',
        //     name: '广州'
        //   }, {
        //     id: 'Dalian',
        //     name: '大连'
        //   }]
        // }],
        // value: [],
        oldOptions:[]
      }
    },
    mounted(){
      //深度克隆搜索前的数据
      this.oldOptions = JSON.parse(JSON.stringify(this.options))
    },
    methods: {
      //节点搜索
      filterNode(value, data){
        if (!value){
          this.options=this.oldOptions
          return true;
        }
        this.options = this.rebuildData(value,this.options)
      },
      //递归模糊搜索
      rebuildData(value, arr){
        let newarr = [];
        arr.forEach(element => {
          if (element.children && element.children.length) {
            const ab = this.rebuildData(value,element.children);
            const obj = {
              ...element,
              children: ab
            };
            if (ab && ab.length) {
              newarr.push(obj);
            }
          } else {
            if (element.name.indexOf(value) > -1) {
              newarr.push(element);
            }
          }
        });
        return newarr;
      },
      //点击一级菜单全选/全不选实现
      checkAll(value){ //value: 点击的一级value
        if(!this.multiple){
          //单选返回
          return false
        }
        if (!value){ return false }
        let childList = [];
        this.options.forEach(element => {
          if(value==element.id){
            childList = element.children
            return childList;
          }
        });
        let level2ValueList = [];
        childList.forEach(element => {
          level2ValueList.push(element.id);
        })
        let num=0;
        let that = this;
        level2ValueList.forEach((value)=>{
          that.value.forEach((model, index)=>{
            if(model==value){
              that.value.splice(index, 1); //如有匹配，先删除
              num++;
              return true;
            }
          })
        })
        if(num < level2ValueList.length){ //需要全选
          that.value = that.value.concat(level2ValueList); //合并数组
        }
      }
    },
    watch: {
      value() {
        // /*this.$emit('update:value', this.value)*/
        this.$emit('input', this.value)
        this.$emit('selectChange')
      }
    }
  }
</script>
<style>
  .tips{
    color: #FF9C00;
    font-size: 12px;
    margin-left: 20px;
  }
</style>
